import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Tally = apiContainer.Tally
//GET--->
// Corrected getTally function
export async function getTallyApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Tally}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createTally(request) {
    try {
        return api.create(`${Tally}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateTally(request, TallyId) {
    try {
        return api.update(`${Tally}/${TallyId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteTally(TallyId) {
    try {
        return api.delete(`${Tally}/${TallyId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



